module.exports = __webpack_public_path__ + "img/logo_blue.d6cf13ba.png";